import React, { useState } from "react";
import ExclamationMarkTrangelIconWithBorder from "assets/svgIcons/AdminDashboard/ExclamationMarkTrangelIcon";
import ModalCloseIcon from "assets/svgIcons/ModalCloseIcon";
import AlertsIcon from "assets/svgIcons/AdminDashboard/ActionZone/AlertsIcon";
import ArrowIcon from "assets/svgIcons/AdminDashboard/ActionZone/ArrowIcon";
import CartPathsIcon from "assets/svgIcons/AdminDashboard/ActionZone/CartpathsIcon";
import GeoFenceIcon from "assets/svgIcons/AdminDashboard/ActionZone/GeofenceIcon";
import {
  ActionZoneModalContainer,
  ActionZoneModalModalBody,
} from "pages/AdminDashboard/AdminDashboardStyled";
import { ModalHeader } from "assets/css/globle";
import { useDispatch, useSelector } from "react-redux";
import { COMMON_SERVICES } from "../../../../redux/reduxToolkitServices/_commonServices/commonServices";
import { useEffect } from "react";
import moment from "moment";
import { Modal } from "@mui/material";
import { Box } from "@mui/system";
import { useTranslation } from "react-i18next";
import { API_STATUSES } from "redux/_helpers/statuses";
import { SITEID_GLOBAL_STATE } from "globalStore/globalStore";
import { useHookstate } from "@hookstate/core";

export const ActionZoneInfraction = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

  const [openAlertModal, setOpenAlertModal] = useState(false);
  const handleAlertModalOpen = () => setOpenAlertModal(true);
  const handleAlertModalClose = () => setOpenAlertModal(false);

  const [openCarPathModal, setOpenCarPathModal] = useState(false);
  const handleCarPathModalOpen = () => setOpenCarPathModal(true);
  const handleCarPathModalClose = () => setOpenCarPathModal(false);

  const [openGeofenceModal, setOpenGeofenceModal] = useState(false);
  const handleGeofenceModalOpen = () => setOpenGeofenceModal(true);
  const handleGeofenceModalClose = () => setOpenGeofenceModal(false);

  const {
    getActionZoneInfractionDataState,
    getActionZoneInfractionDataStatus,
    getActionZoneInfractionChildDataState,
    siteSettingsData,
    getDashboardFeatureSetStatus,
  } = useSelector((state) => state.commonReducers);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: 900,
    bgcolor: "background.paper",
    boxShadow: 24,
    width: "100%",
    background: "#FFFFFF",
    boxShadow: "0px 14px 100px 30px rgba(0, 0, 0, 0.3)",
    borderRadius: "20px",
    outline: "none",
  };

  useEffect(() => {
    if (
      getDashboardFeatureSetStatus === API_STATUSES.SUCCESS &&
      siteSettingsData &&
      Object.keys(siteSettingsData).length > 0
    ) {
      dispatch(
        COMMON_SERVICES.getActionZoneInfractionServices(
          moment()
            .utc()
            .utcOffset(-siteSettingsData?.TimeZoneOffset)
            .format("YYYY-MM-DD"),
          localStorage.getItem("dashCourseId"), siteId.get()
        )
      );
    }
  }, [
    getDashboardFeatureSetStatus,
    localStorage.getItem("dashCourseId"),
    siteSettingsData,
  ]);

  if (getActionZoneInfractionDataStatus === "request") {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          justifyContent: "center",
          alignItems: "center",
          textTransform: "capitalize",
        }}
      >
        {t("loading_data")} ...
      </div>
    );
  }

  if (getActionZoneInfractionDataStatus === "error") {
    return <></>;
  }

  const getActionZoneData = (apiDetector) => {
    if (apiDetector === "ActionZoneAlertCount") {
      dispatch(
        COMMON_SERVICES.getActionZoneInfractionChildItemServices(
          moment().format("YYYY-MM-DD"),
          apiDetector, siteId.get()
        )
      );

      handleAlertModalOpen();
    } else if (apiDetector === "CarsInCartPath") {
      handleCarPathModalOpen();
      dispatch(
        COMMON_SERVICES.getActionZoneInfractionChildItemServices(
          moment().format("YYYY-MM-DD"),
          apiDetector, siteId.get()
        )
      );
    } else {
      handleGeofenceModalOpen();
      dispatch(
        COMMON_SERVICES.getActionZoneInfractionChildItemServices(
          moment().format("YYYY-MM-DD"),
          apiDetector, siteId.get()
        )
      );
    }
  };

  const alertModal = () => {
    return (
      <Modal
        open={openAlertModal}
        onClose={handleAlertModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <ActionZoneModalContainer>
            <ModalHeader>
              <h2>{t("Alerts")}</h2>
              <ModalCloseIcon onClick={handleAlertModalClose} />
            </ModalHeader>
            <ActionZoneModalModalBody>
              <table>
                <tr>
                  <th>{t("Action_Zone")}</th>
                  <th>{t("Hole_No")}.</th>
                  <th>{t("Car_No")}.</th>
                  <th>
                    {t("Player_name(s)")}
                  </th>
                  <th>{t("Alert")}</th>
                </tr>
                {getActionZoneInfractionChildDataState &&
                getActionZoneInfractionChildDataState.length !== 0 ? (
                  getActionZoneInfractionChildDataState.map((item, index) => (
                    <tr key={index + "kdfjjsdf"}>
                      <td>{item?.ActionZone}</td>
                      <td>{item?.HoleNo}</td>
                      <td>{item?.CarNo}</td>
                      <td>{item?.Player}</td>
                      <td>{item?.Alert}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={5}>{t("No_Data_Found")}</td>
                  </tr>
                )}
              </table>
            </ActionZoneModalModalBody>
          </ActionZoneModalContainer>
        </Box>
      </Modal>
    );
  };
  
  const carpathModal = () => {
    return (
      <Modal
        open={openCarPathModal}
        onClose={handleCarPathModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <ActionZoneModalContainer>
            <ModalHeader>
              <h2>{t("Cartpaths")}</h2>
              <ModalCloseIcon onClick={handleCarPathModalClose} />
            </ModalHeader>
            <ActionZoneModalModalBody>
              <table>
                <tr>
                  <th>{t("Hole_No")}.</th>
                  <th>{t("Car_No")}.</th>
                  <th>
                    {t("Player_name(s)")}
                  </th>
                  <th>{t("Alert")}</th>
                </tr>
                {getActionZoneInfractionChildDataState &&
                getActionZoneInfractionChildDataState.length !== 0 ? (
                  getActionZoneInfractionChildDataState.map((item, index) => {
                    return (
                      <tr key={index + "kdfjjsdf"}>
                        <td>{item?.HoleNo}</td>
                        <td>{item?.CarNo}</td>
                        <td>{item?.Player}</td>
                        <td>{item?.Alert}</td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={4}>{t("No_Data_Found")}</td>
                  </tr>
                )}
              </table>
            </ActionZoneModalModalBody>
          </ActionZoneModalContainer>
        </Box>
      </Modal>
    );
  };

  const geofenceModal = () => {
    return (
      <Modal
        open={openGeofenceModal}
        onClose={handleGeofenceModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <ActionZoneModalContainer>
            <ModalHeader>
              <h2>{t("Geofence")}</h2>
              <ModalCloseIcon onClick={handleGeofenceModalClose} />
            </ModalHeader>
            <ActionZoneModalModalBody>
              <table>
                <tr>
                  <th>{t("Car_No")}.</th>
                  <th>
                    {t("Player_name(s)")}
                  </th>
                  <th>
                    {t("Geofence_location")}
                  </th>
                </tr>
                {getActionZoneInfractionChildDataState &&
                getActionZoneInfractionChildDataState.length !== 0 ? (
                  getActionZoneInfractionChildDataState.map((item, index) => (
                    <tr key={index + "kdfjjsdf"}>
                      <td>{item?.CarNo}</td>
                      <td>{item?.Player}</td>
                      <td>{item?.Alert}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4}>{t("No_Data_Found")}</td>
                  </tr>
                )}
              </table>
            </ActionZoneModalModalBody>
          </ActionZoneModalContainer>
        </Box>
      </Modal>
    );
  };

  return (
    <>
      {alertModal()}
      {carpathModal()}
      {geofenceModal()}
      <div className="header">
        <ExclamationMarkTrangelIconWithBorder />
        <p className="red-border">{t("Action_Zone_Infraction")}</p>
      </div>
      <div className="box-body action-zone-infraction">
        <div onClick={() => getActionZoneData("ActionZoneAlertCount")}>
          <p>
            <AlertsIcon />
            {t("Alerts")}
          </p>
          <h4>
            {getActionZoneInfractionDataState &&
              getActionZoneInfractionDataState?.ActionZoneAlertCount}
          </h4>
          <ArrowIcon />
        </div>
        <div onClick={() => getActionZoneData("CarsInCartPath")}>
          <p>
            <CartPathsIcon />
            {t("Cartpaths")}
          </p>
          <h4>
            {getActionZoneInfractionDataState &&
              getActionZoneInfractionDataState?.CarsInCartPath}
          </h4>
          <ArrowIcon />
        </div>
        <div onClick={() => getActionZoneData("CarsInGeoFence")}>
          <p>
            <GeoFenceIcon />
            {t("Geofence")}
          </p>
          <h4>
            {getActionZoneInfractionDataState &&
              getActionZoneInfractionDataState?.CarsInGeoFence}
          </h4>
          <ArrowIcon />
        </div>
      </div>
    </>
  );
};
